import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			- Vivi ne eblas kun tiuj loloj! – indignas la Spiko. 
			– Batu ilin hajlo, forbruligu la fulmo!
		</p>
		
		<p class="mb-3">
			- Kion vi diras! – admonas lin aliuj spikoj. 
			– Se okazos fajro, ni ĉiuj forbrulos, neniu saviĝos.
		</p>
		
		<p class="mb-3">
			- Do forbrulu ni! – arde eksklamas la Spiko. 
			– Anstataŭe sur nia loko elkreskos aliuj spikoj!
		</p>
		
		<p class="mb-3">
			- Kaj se elkreskos loloj?
		</p>
	`
	)
}

const itemName = {
	esp: 'Cerealoj'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;